import { createContext } from 'react'

export const FormContext = createContext({
	inputs: {},
	touched: false,
	updateInputValue: () => {
	},
	updateInputState: () => {
	},
	removeInput: () => {
	},
})